import React, { forwardRef } from 'react';
import { connect } from 'react-redux';

import { getState } from './../../../Service/selectors';

import ServicesSelect from './components';

const mapStateToProps = (state, props) => {
    return {
        loading: props.loading || getState(state, 'loadingServices') || getState(state, 'loadingConsignServices')
    };
};

const ServicesSelectContainer = forwardRef((props, ref) => {
    return (
        <ServicesSelect {...props} ref={ref} />
    );
});

export default connect(
    mapStateToProps,
    undefined,
    undefined,
    {
        forwardRef: true
    }
)(ServicesSelectContainer);
